import React from 'react';
import PropTypes from 'prop-types';
import { getAnswerClass } from './utils';
import { QUESTION_MATRIX_MULTIPLE } from '../../../constants';
import { transformPrompt } from '../../../utils';

export default function MatrixVertical({
  question,
  rows,
  columns,
  onHandleMatrixQuestionTap,
  onHandleMatrixAnswerTap,
  onHandleMatrixHideAnswersButton,
  getText,
}) {
  return (
    <div className="matrix-wrapper">
      {rows.map((row, index) => {
        const rowColumns = columns[index];
        return (
          <div
            className="matrix clearfix answerMatrix"
            data-answer-id={row.id}
            key={row.id}
          >
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
            <div
              className="matrix__question inline-children"
              data-testid="matrix-row"
              onClick={onHandleMatrixQuestionTap}
              role="button"
              tabIndex={0}
            >
              <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: transformPrompt(row.body) || '&nbsp;',
                }}
              />
              <div className="matrix__labels">
                {rowColumns.map((column) => (
                  <span
                    key={`label-${column.id}`}
                    className="matrix__selected-answer"
                    data-scorepoint-id={column.id}
                    data-answer-id={row.id}
                  >
                    <span
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: transformPrompt(column.body) || '&nbsp;',
                      }}
                    />
                  </span>
                ))}
              </div>
            </div>
            <div className="matrix__answers" data-answer-id={row.id}>
              {rowColumns.map((column) => (
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
                <div
                  key={column.id}
                  data-answer-id={row.id}
                  data-scorepoint-id={column.id}
                  className={`matrix__answer inline-children ${getAnswerClass({
                    question,
                    column,
                  })}`}
                  onClick={onHandleMatrixAnswerTap}
                  role="button"
                  tabIndex={0}
                >
                  <span
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: transformPrompt(column.body) || '&nbsp;',
                    }}
                  />
                </div>
              ))}
              {question.style === QUESTION_MATRIX_MULTIPLE && (
                <div className="text-center">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    href="#"
                    data-answer-id={row.id}
                    className="matrix__hide-answers-btn"
                    onClick={onHandleMatrixHideAnswersButton}
                    role="button"
                    tabIndex={0}
                  >
                    {getText('hide_answers_multimatrix_prompt')}
                  </a>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

MatrixVertical.propTypes = {
  question: PropTypes.object,
  rows: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  onHandleMatrixQuestionTap: PropTypes.func.isRequired,
  onHandleMatrixAnswerTap: PropTypes.func.isRequired,
  onHandleMatrixHideAnswersButton: PropTypes.func.isRequired,
  getText: PropTypes.func.isRequired,
};
